import React, { useEffect, useRef, useState } from 'react';
import {  Card, Row, Col, } from 'antd';
import BarcodeScannerComponent from "react-qr-barcode-scanner";


import QrReader from 'react-qr-reader';
/* eslint-disable-next-line */
export interface BarCodeScannerContainerProps { }

export function BarCodeScannerContainer(
    props: BarCodeScannerContainerProps
) {

    const [data, setData] = React.useState<any>();
    const [stopStream, setStopStream] = React.useState(false);


   

    return (
        <Card title={<span style={{ color: 'white' }}>Barcode Sacn</span>}
            style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }} >


            <Row gutter={24}>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
                    <h3>Barcode Scan by Web Cam</h3><br /><br />
                    <>
                        <BarcodeScannerComponent
                            width={500}
                            height={500}
                            stopStream={stopStream}
                            onUpdate={(err, result) => {
                                if (result) {
                                    setData(result);
                                    setStopStream(true);
                                } else {
                                    setData("Not Found");
                                }
                            }}
                        />
                    </>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
                    <h3>Scanned By WebCam Code: </h3>
                    <br /><br />
                    <p>    {data}</p>
                </Col>
            </Row>






        </Card>
    );
}

export default BarCodeScannerContainer;
